import { faqItems } from '@/mocks/homeData';

export default function FAQ() {
  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">快速了解春夜影院</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <details key={item.id} className="group bg-background-100 rounded-lg overflow-hidden">
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</h3>
                <i className="ri-add-line text-foreground-400 group-open:hidden text-lg flex-shrink-0"></i>
                <i className="ri-subtract-line text-primary-500 hidden group-open:block text-lg flex-shrink-0"></i>
              </summary>
              <div className="px-5 md:px-6 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}